<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 1부((Incorporated In Singapore)). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <p class="doc-p center bold"><CddVarField field-key="company_name" label="Company Name" /></p>
    <p class="doc-p center">(Incorporated In Singapore)</p>
    <p class="doc-p center">Company Registration No. <CddVarField field-key="company_registration_no" label="Company Registration No." /></p>
    <div class="gap" />
    <p class="doc-p center bold">DIRECTORS' RESOLUTIONS IN WRITING PURSUANT TO </p>
    <p class="doc-p center bold">THE COMPANY'S CONSTITUTION</p>
    <p class="doc-p bold">——————————————————————————————————————————</p>
    <div class="gap" />
    <p class="doc-p bold">AUDITED FINANCIAL STATEMENTS AND DIRECTORS’ STATEMENTS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that the audited financial statements of the Company for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> together with the directors' statement thereon be approved and that the said directors' statement be signed by directors of the Company.</p>
    <div class="gap" />
    <p class="doc-p bold">RE-ELECTION OF DIRECTORS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that <CddVarField field-key="reelected_directors" label="Re-elected directors (e.g. A, B and C)" />, be hereby re-elected as Directors of Company</p>
    <div class="gap" />
    <p class="doc-p bold">DIRECTORS’ REMUNERATION</p>
    <div class="gap" />
    <p class="doc-p">Resolved that Directors’ Remuneration and/or Benefit-in-kind (if any) as shown in the audited Financial Statements for the year ended <CddVarField field-key="financial_year_end" label="FYE" /> and paid to Director(s) be and is/are hereby approved.</p>
    <div class="gap" />
    <p class="doc-p">&emsp;Resolved that Directors’ Remuneration of S$<CddVarField field-key="directors_remuneration_amount" label="Remuneration amount (e.g. 120,000)" /> paid to the following Directors as shown in the trading, profit and loss account for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> be hereby approved: -</p>
    <div class="gap" />
    <p class="doc-p bold">DIRECTORS’ FEES</p>
    <div class="gap" />
    <p class="doc-p">Resolved that Directors’ Fees of <CddVarField field-key="directors_fees" label="Directors’ fees" /> for financial year end <CddVarField field-key="financial_year_end" label="FYE" />, as stated in the financial statements be and is hereby approved at the forthcoming Annual General Meeting.</p>
    <div class="gap" />
    <p class="doc-p bold">INTERIM/FINAL DIVIDEND</p>
    <div class="gap" />
    <p class="doc-p">Resolved that a final one-tier tax exempt dividend of <CddVarField field-key="final_dividend" label="Final dividend per share" /> per ordinary share for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> is hereby approved at the forthcoming Annual General Meeting.</p>
    <div class="gap" />
    <p class="doc-p bold">RELATED PARTY TRANSACTIONS</p>
    <div class="gap" />
    <p class="doc-p">RESOLVED that the following related party transactions for the financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> be and are hereby approved:</p>
    <div class="gap" />
    <p class="doc-p bold">RE-APPOINTMENT OF AUDITORS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that <CddVarField field-key="auditor_name" label="Auditor" /> (UEN: <CddVarField field-key="auditor_uen" label="Auditor UEN" />) as the Company’s Auditor be and is hereby approved to be re-appointed at the forthcoming Annual General Meeting.</p>
    <p class="doc-p bold">ANNUAL GENERAL MEETING</p>
    <div class="gap" />
    <p class="doc-p">Resolved that the Annual General Meeting of the Company be convened as soon as practicable and that any Director be and is hereby authorised to issue notice in respect thereof.</p>
    <div class="gap" />
    <p class="doc-p bold">AUTHORITY TO E-FILE RETURNS</p>
    <div class="gap" />
    <p class="doc-p">Resolved that any officer of the Company or such other person(s) as directed by the directors be authorised to e-file the relevant returns relating thereto with the Accounting and Corporate Regulatory Authority, for and on behalf of the Company. </p>
    <div class="gap" />
    <p class="doc-p">Date: <CddVarField field-key="agm_date" label="AGM date" /></p>
    <div class="gap" />
    <p class="doc-p">DIRECTORS</p>
    <div class="gap" />
    <AgmSigners var-key="agm_Signers" board-label="DIRECTORS" />
    <div class="gap" />
  </div>
</template>
